var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},_vm._l((_vm.companyObj.info),function(item,index){return _c('p',{key:index},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }